export default [
  {
    name: '/MyActivity',
    path: '/MyActivity',
    meta: { title: '我的活动' },
    component: () =>
      import(
        /* webpackChunkName: "MyActivity" */
        '@/pages/ticketing/MyActivity'
      )
  },
  {
    name: 'ActDetail',
    path: '/ActDetail',
    meta: { title: '加载中...' },
    component: () =>
      import(
        /* webpackChunkName: "ActDetail" */
        '@/pages/ticketing/ActDetail'
      )
  },
  {
    name: 'ActivityJoin',
    path: '/ActivityJoin',
    meta: { title: '参与用户' },
    component: () =>
      import(
        /* webpackChunkName: "ActivityJoin" */
        '@/pages/ticketing/ActivityJoin'
      )
  },
  {
    name: 'ActivityForm',
    path: '/ActivityForm',
    meta: { title: '表单填写' },
    component: () =>
      import(
        /* webpackChunkName: "ActivityForm" */
        '@/pages/ticketing/ActivityForm'
      )
  },
  {
    name: 'ActSignUp',
    path: '/ActSignUp',
    meta: { title: '报名' },
    component: () =>
      import(
        /* webpackChunkName: "ActSignUp" */
        '@/pages/ticketing/ActSignUp'
      )
  },
  {
    name: 'ActMyTicket',
    path: '/ActMyTicket',
    meta: { title: '我的票券' },
    component: () =>
      import(
        /* webpackChunkName: "ActMyTicket" */
        '@/pages/ticketing/ActMyTicket'
      )
  },
  {
    name: 'ActShareTicket',
    path: '/ActShareTicket',
    meta: { title: '分享票券' },
    component: () =>
      import(
        /* webpackChunkName: "ActShareTicket" */
        '@/pages/ticketing/ActShareTicket'
      )
  },
  {
    name: 'ActGetTicket',
    path: '/ActGetTicket',
    meta: { title: '领取票券' },
    component: () =>
      import(
        /* webpackChunkName: "ActGetTicket" */
        '@/pages/ticketing/ActGetTicket'
      )
  },
  {
    name: 'ActSignIn',
    path: '/ActSignIn',
    meta: { title: '签到' },
    component: () =>
      import(
        /* webpackChunkName: "ActSignIn" */
        '@/pages/ticketing/ActSignIn'
      )
  },
  {
    name: 'ActInvitation',
    path: '/ActInvitation',
    meta: { title: '邀请榜' },
    component: () =>
      import(
        /* webpackChunkName: "ActInvitation" */
        '@/pages/ticketing/ActInvitation'
      )
  },
  {
    name: 'loadingPage',
    path: '/loadingPage',
    meta: { title: '加载中' },
    component: () =>
      import(
        /* webpackChunkName: "ActInvitation" */
        '@/pages/ticketing/loadingPage'
      )
  }
]
